import { gql } from '@apollo/client';
import { swapFragment, swapTaskFragment } from '../fragments';
export const getSwapTaskQuery = gql `
  query GetSwapTask($record: SwapTaskRecord!) {
    getSwapTask(record: $record) {
      ...swapTaskFields
      destinationNetwork {
        id
      }
      sourceNetwork {
        id
      }
      totals {
        stillToReceive
        totalDeposited
        totalReceived
      }
      destinationAsset {
        iconUrl
        code
        assetSupportedNetworks {
          fireblocksId
          network {
            id
          }
        }
      }
      sourceAsset {
        iconUrl
        code
        assetSupportedNetworks {
          fireblocksId
          network {
            id
          }
        }
      }
      account {
        address
      }
      swaps {
        ...swapFields
        exchange {
          originalAmount
        }
        calculatedData {
          receivedAmount
        }
        deposit {
          amount
          hash
        }
        withdrawal {
          amount
          hash
        }
      }
    }
  }

  ${swapTaskFragment}
  ${swapFragment}
`;
//# sourceMappingURL=getSwapTask.js.map